export { default as AdditionalPaymentMethodsTxa } from './src/additional-payment-methods-txa';
export { default as AdditionalPaymentMethods } from './src/additional-payment-methods';
